var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForwardStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264 64C250.746 64 240 74.746 240 88V193.83L66.594 69.969C61.07 66.004 54.553 64.004 48.004 64.002C42.992 64.002 37.963 65.174 33.344 67.531C22.688 73.031 16 84 16 96V416C16 428 22.688 438.969 33.344 444.469C37.969 446.844 43 448 48 448C54.562 448 61.062 446 66.594 442.031L240 318.17V424C240 437.254 250.746 448 264 448S288 437.254 288 424V88C288 74.746 277.254 64 264 64ZM240 259.182L212.102 279.111L64 384.896V127.104L212.1 232.889L240 252.816V259.182Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardStep);
export default __webpack_public_path__ + "static/media/forward-step.53452ded19abac5946bf0d52d11511a3.svg";
export { ForwardRef as ReactComponent };